import { Injectable } from '@angular/core';
import { SideMenuService } from '@services/menu/side-menu.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { UploadsMenuEntry } from '../../../schema/menu/uploads-menu-entry';
import { UploadsMenuControllerService } from '../../uploads-menu-controller/uploads-menu-controller.service';

@AddinExecute({
  name: 'Add menu to monitor and control uploads'
})
@Injectable()
export class UploadsMenuSetupService extends Execute {
  private uploadsMenuEntry = new UploadsMenuEntry();

  constructor(
    private sideMenu: SideMenuService,
    private profile: ProfileService,
    private uploadsMenuController: UploadsMenuControllerService
  ) {
    super();
  }

  execute() {
    this.profile.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => this.setup());
  }

  private setup() {
    this.sideMenu.addMenuEntry(this.uploadsMenuEntry);
    this.uploadsMenuController.setup(this.uploadsMenuEntry);
  }
}
